(function () {
  function initWrap(wrap) {
    if (!wrap || wrap.__adfInit) return;
    wrap.__adfInit = true;

    var blockId = wrap.id.replace('adf-', '');
    var dataEl = document.getElementById('adf-data-' + blockId);
    if (!dataEl) return;

    var payload = {};
    try { payload = JSON.parse(dataEl.textContent.trim()); } catch (e) { payload = {}; }
    var variantsList = payload.variants || [];
    var variantsById = {};
    variantsList.forEach(function (v) { variantsById[String(v.id)] = v; });

    var optionsOrder = payload.options || [];
    var pill = wrap.querySelector('.adf-pill');
    var targetDiscount = +wrap.getAttribute('data-target-discount') || 0;

    var root = wrap.closest('[id^="shopify-section"]') || document;
    var variantIdInput = root.querySelector('form[action*="/cart/add"] input[name="id"]');

    var blockItem = wrap.closest('.product-info__block-item');

    function hide() {
      pill.classList.remove('adf-show');
      wrap.style.display = 'none';
      if (blockItem) { blockItem.style.margin = '0'; blockItem.style.padding = '0'; blockItem.style.lineHeight = '0'; blockItem.style.fontSize = '0'; }
    }
    function show() {
      pill.classList.add('adf-show');
      wrap.style.display = '';
      if (blockItem) { blockItem.style.margin = ''; blockItem.style.padding = ''; blockItem.style.lineHeight = ''; blockItem.style.fontSize = ''; }
    }

    function renderByVariantId(vid) {
      var v = variantsById[String(vid)];
      if (!v) return hide();
      var price = +v.price || 0, compare = +v.compare || 0;
      if (compare > price && compare > 0) {
        var pct = Math.round(((compare - price) / compare) * 100);
        if (pct === targetDiscount) show(); else hide();
      } else { hide(); }
    }

    function getSelectedOptions() {
      var vals = [];
      optionsOrder.forEach(function (_, idx) {
        var i = idx + 1;
        var sel = root.querySelector('select[name^="options["][name*="' + i + '"]');
        if (sel) { vals[idx] = sel.value; return; }
        var checked = root.querySelector('input[type="radio"][name^="options["][name*="' + i + '"]:checked');
        if (checked) { vals[idx] = checked.value; return; }
      });
      return vals;
    }

    function variantIdFromOptions(vals) {
      for (var i = 0; i < variantsList.length; i++) {
        var v = variantsList[i], ok = true;
        if (vals[0] && v.o1 !== vals[0]) ok = false;
        if (vals[1] && v.o2 !== vals[1]) ok = false;
        if (vals[2] && v.o3 !== vals[2]) ok = false;
        if (ok) return v.id;
      }
      return null;
    }

    function getVariantIdFromURL() {
      try { return new URL(location.href).searchParams.get('variant'); } catch (_) { return null; }
    }

    function recomputeAndRender() {
      if (variantIdInput && variantIdInput.value) return renderByVariantId(variantIdInput.value);
      var urlVid = getVariantIdFromURL(); if (urlVid) return renderByVariantId(urlVid);
      var vals = getSelectedOptions(); var vid = variantIdFromOptions(vals); if (vid) renderByVariantId(vid);
    }

    recomputeAndRender();

    root.addEventListener('change', function (e) {
      var n = (e.target && e.target.name) || '';
      if (n.indexOf('options') === 0 || n === 'id') recomputeAndRender();
    });

    if (variantIdInput) {
      variantIdInput.addEventListener('change', recomputeAndRender);
      new MutationObserver(recomputeAndRender).observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
    }

    ['variant:change', 'variant:changed', 'product:variant-change', 'theme:variant:change', 'product:change', 'theme:product:change']
      .forEach(function (evt) {
        document.addEventListener(evt, function (e) {
          var vid = (e && e.detail && (e.detail.id || (e.detail.variant && e.detail.variant.id))) || null;
          if (vid) renderByVariantId(vid); else recomputeAndRender();
        });
      });

    ['pushState', 'replaceState'].forEach(function (m) {
      if (!history[m]._adfWrapped) {
        var orig = history[m];
        history[m] = function () {
          var ret = orig.apply(this, arguments);
          try {
            if (arguments && arguments[2] && String(arguments[2]).indexOf('variant=') > -1) {
              document.querySelectorAll('.adf-wrap').forEach(function (w) {
                if (w.__adfInit && typeof w.__adfRecompute === 'function') w.__adfRecompute();
              });
            }
          } catch (_) {}
          return ret;
        };
        history[m]._adfWrapped = true;
      }
    });

    wrap.__adfRecompute = recomputeAndRender;
    window.addEventListener('popstate', recomputeAndRender);
  }

  function boot() { document.querySelectorAll('.adf-wrap').forEach(initWrap); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:block:select', boot);
})();
